import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sf-cover" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "sf-cover__info" }
const _hoisted_4 = { class: "sf-cover__logo" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 2,
  class: "sf-cover__logo-skeleton sf-skeleton animate-pulse"
}
const _hoisted_8 = { class: "sf-cover__text" }
const _hoisted_9 = {
  key: 0,
  class: "sf-heading sf-cover__name"
}
const _hoisted_10 = {
  key: 1,
  class: "sf-cover__name-skeleton sf-skeleton animate-pulse"
}
const _hoisted_11 = {
  key: 2,
  class: "sf-cover__status"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "sf-cover__dot" }, null, -1)
const _hoisted_13 = {
  key: 1,
  class: "sf-cover__min"
}

import { computed, onBeforeUnmount, ref, watch } from 'vue'
import { restaurant } from '@/global/state/GlobalState'
import { storefront } from '@/global/state/StorefrontState'
import { formatBRL, getStoreStatus, resolveMediaUrl } from './storefrontUtils'


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreCover',
  setup(__props) {

const logoFailed = ref(false)
const logo = computed(() => (logoFailed.value ? '' : restaurant.value?.restaurantDesignCustom?.logo || ''))
watch(() => restaurant.value?.restaurantDesignCustom?.logo, () => { logoFailed.value = false })

const bannerStyle = computed(() => {
  const url = resolveMediaUrl(storefront.value.settings.coverImageUrl)
  if (url) return { backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0) 55%, rgba(0,0,0,.25)), url("${url}")` }
  return { backgroundImage: 'linear-gradient(135deg, var(--sf-primary) 0%, var(--sf-secondary) 140%)' }
})

// Recalculated every minute so "Aberto/Fechado" doesn't go stale on an open tab
const now = ref(new Date())
const clock = setInterval(() => { now.value = new Date() }, 60000)
onBeforeUnmount(() => clearInterval(clock))
const status = computed(() => (restaurant.value?.id ? getStoreStatus(restaurant.value, now.value) : null))

const minimumOrder = computed(() => {
  const value = Number(restaurant.value?.restaurantConfig?.minimumOrderAmount)
  return value > 0 ? formatBRL(value) : ''
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", {
      class: "sf-cover__banner",
      style: _normalizeStyle(bannerStyle.value),
      role: "img",
      "aria-label": `Capa de ${_unref(restaurant)?.name || 'loja'}`
    }, null, 12, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (logo.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: logo.value,
              alt: _unref(restaurant)?.name || 'logo',
              onError: _cache[0] || (_cache[0] = ($event: any) => (logoFailed.value = true))
            }, null, 40, _hoisted_5))
          : (_unref(restaurant)?.name)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(restaurant).name.trim().charAt(0).toUpperCase()), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_7))
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_unref(restaurant)?.name)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_9, _toDisplayString(_unref(restaurant).name), 1))
          : (_openBlock(), _createElementBlock("h1", _hoisted_10)),
        (status.value || minimumOrder.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
              (status.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["sf-cover__badge", status.value.open ? 'is-open' : 'is-closed'])
                  }, [
                    _hoisted_12,
                    _createTextVNode(_toDisplayString(status.value.label), 1)
                  ], 2))
                : _createCommentVNode("", true),
              (minimumOrder.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Pedido mínimo " + _toDisplayString(minimumOrder.value), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})